import styled from "styled-components";
import { fontFamilies, fontSizes } from "components/shared/tokens/typography";
import red from "components/shared/tokens/color/red";

const DARK_NAVY = "#293142";
const BORDER = "#e1e5ed";

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownLabel = styled.span`
  position: absolute;
  top: 0;
  left: 10px;
  z-index: 1;
  padding: 0 4px;
  transform: translateY(-50%);
  background: ${({ $disabled }) => ($disabled ? "#f5f6f9" : "#ffffff")};
  color: #9299aa;
  font-family: ${fontFamilies.regular};
  font-size: ${fontSizes.z100};
  line-height: 1.2;
`;

export const DropdownTrigger = styled.button`
  width: 100%;
  min-height: 49px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: ${({ $hasValue }) => ($hasValue ? "16px 12px 7px" : "12px")};
  border: 1px solid ${BORDER};
  border-radius: 9px;
  background: ${({ disabled }) => (disabled ? "#f5f6f9" : "#ffffff")};
  color: ${({ $hasValue }) => ($hasValue ? DARK_NAVY : "#9299aa")};
  font-family: ${fontFamilies.regular};
  font-size: ${fontSizes.z300};
  text-align: left;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};

  svg {
    width: 25px;
    height: 25px;
    flex: 0 0 25px;
    color: #9299aa;
    stroke-width: 2;
  }

  &:focus-visible {
    border-color: ${red.z400};
    box-shadow: 0 0 0 2px ${red.z100};
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  z-index: 20;
  overflow: hidden;
  padding: 4px;
  border: 1px solid ${BORDER};
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(41, 49, 66, 0.14);
`;

export const DropdownOption = styled.button`
  width: 100%;
  padding: 11px 10px;
  border: 0;
  border-radius: 7px;
  background: ${({ $isSelected }) => ($isSelected ? red.z50 : "transparent")};
  color: ${({ $isSelected }) => ($isSelected ? red.z500 : DARK_NAVY)};
  font-family: ${fontFamilies.regular};
  font-size: ${fontSizes.z200};
  text-align: left;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: ${red.z50};
  }
`;
